__turbopack_context__.v({
  "devGrid": "DevGrid-module-scss-module__EiZKUW__devGrid",
  "stack-module-0": "DevGrid-module-scss-module__EiZKUW__stack-module-0",
  "stack-module-1": "DevGrid-module-scss-module__EiZKUW__stack-module-1",
  "stack-module-10": "DevGrid-module-scss-module__EiZKUW__stack-module-10",
  "stack-module-11": "DevGrid-module-scss-module__EiZKUW__stack-module-11",
  "stack-module-12": "DevGrid-module-scss-module__EiZKUW__stack-module-12",
  "stack-module-13": "DevGrid-module-scss-module__EiZKUW__stack-module-13",
  "stack-module-14": "DevGrid-module-scss-module__EiZKUW__stack-module-14",
  "stack-module-15": "DevGrid-module-scss-module__EiZKUW__stack-module-15",
  "stack-module-16": "DevGrid-module-scss-module__EiZKUW__stack-module-16",
  "stack-module-17": "DevGrid-module-scss-module__EiZKUW__stack-module-17",
  "stack-module-18": "DevGrid-module-scss-module__EiZKUW__stack-module-18",
  "stack-module-19": "DevGrid-module-scss-module__EiZKUW__stack-module-19",
  "stack-module-2": "DevGrid-module-scss-module__EiZKUW__stack-module-2",
  "stack-module-20": "DevGrid-module-scss-module__EiZKUW__stack-module-20",
  "stack-module-3": "DevGrid-module-scss-module__EiZKUW__stack-module-3",
  "stack-module-4": "DevGrid-module-scss-module__EiZKUW__stack-module-4",
  "stack-module-5": "DevGrid-module-scss-module__EiZKUW__stack-module-5",
  "stack-module-6": "DevGrid-module-scss-module__EiZKUW__stack-module-6",
  "stack-module-7": "DevGrid-module-scss-module__EiZKUW__stack-module-7",
  "stack-module-8": "DevGrid-module-scss-module__EiZKUW__stack-module-8",
  "stack-module-9": "DevGrid-module-scss-module__EiZKUW__stack-module-9",
  "z-base": "DevGrid-module-scss-module__EiZKUW__z-base",
  "z-content": "DevGrid-module-scss-module__EiZKUW__z-content",
  "z-footer": "DevGrid-module-scss-module__EiZKUW__z-footer",
  "z-header": "DevGrid-module-scss-module__EiZKUW__z-header",
  "z-hero": "DevGrid-module-scss-module__EiZKUW__z-hero",
  "z-logo": "DevGrid-module-scss-module__EiZKUW__z-logo",
  "z-logo-effect": "DevGrid-module-scss-module__EiZKUW__z-logo-effect",
  "z-navigation": "DevGrid-module-scss-module__EiZKUW__z-navigation",
  "z-sub": "DevGrid-module-scss-module__EiZKUW__z-sub",
});
